import { useState } from 'react';

import { IconSync } from '@iwoca/icons';
import { Button, Modal } from '@iwoca/orion';

import { useGetANTFormalOffers } from '../../../hooks/useGetANTFormalOffers';
import { useUpdateTurnover } from '../../../hooks/useUpdateTurnover';
import { formatCurrency } from '../../../utils/currency';

export const RefreshExpiredLimits = ({
  loading,
  setIsSpendingLimitDrawerOpen,
  refreshSpendingLimit,
}: {
  loading: boolean;
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refreshSpendingLimit: () => void;
  className?: string;
}) => {
  const [showSupersedeModal, setShowSupersedeModal] = useState(false);
  const { antFormalOffers } = useGetANTFormalOffers();
  const coreANTOffers = antFormalOffers.filter(
    (offer) => offer?.product_type !== 'iwocapay',
  );

  const { isTurnoverExpired } = useUpdateTurnover();

  const handleClick = () => {
    if (coreANTOffers.length > 0) {
      return setShowSupersedeModal(true);
    }
    setIsSpendingLimitDrawerOpen(true);
    if (!isTurnoverExpired) {
      refreshSpendingLimit();
    }
  };

  return (
    <>
      <Modal isOpen={showSupersedeModal} onClose={() => {}}>
        <h1 className="mt-s text-xl font-bold">
          Once you hit continue we'll need to re-run your existing Flexi-Loan
          offer for {formatCurrency(coreANTOffers[0]?.available_credit || 0)}
        </h1>
        <p className="mt-s text-m font-reg">
          Don't worry &mdash; you won't need to give us any more documents to do
          this. To see your Flexi-Loan offer, go to your iwoca dashboard.
        </p>
        <div className="mt-s flex gap-s">
          <Button onClick={() => refreshSpendingLimit()}>
            Continue with iwocaPay
          </Button>
          <Button
            onClick={() => setShowSupersedeModal(false)}
            variant="tertiary"
          >
            Go back
          </Button>
        </div>
      </Modal>
      <button
        className={`grid cursor-pointer grid-cols-[15px_1fr] items-center gap-xs bg-transparent p-0 text-[color:var(--color-primary-40,#4b4bff)]`}
        onClick={handleClick}
        disabled={loading}
        title="Subject to approval and reassessed every 30 days — if something changes with your business the amounts might change."
      >
        {loading ? (
          <>
            <IconSync className="h-[15px] w-[18px] animate-spin" />
            <div>Checking limit...</div>
          </>
        ) : (
          <>
            <IconSync className="h-[15px] w-[18px]" />
            <div>Secure my limit</div>
          </>
        )}
      </button>
    </>
  );
};
